import { CircleHelp, PanelLeft, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Kbd } from '@/components/ui/misc'
import { t } from '@/lib/text'
import { useShell } from './ShellContext'
import { NotificationBell } from '@/modules/notifications/NotificationBell'
import { UserMenu } from './UserMenu'
import { AppName } from './environment'

/** One line, at most 64 px: sidebar trigger · search · ? · notifications bell · avatar menu. */
export function Header({ onToggleSidebar }: { onToggleSidebar: () => void }) {
  const { openPalette, openHelp } = useShell()
  return (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b bg-background/95 px-2 backdrop-blur md:px-4">
      <Button variant="ghost" size="icon" className="max-md:hidden" onClick={onToggleSidebar} aria-label={t('core.shell.toggle_sidebar')}>
        <PanelLeft aria-hidden />
      </Button>
      <AppName className="flex min-w-0 items-center px-2 font-semibold md:hidden" />
      <button
        type="button"
        onClick={openPalette}
        className="flex h-9 min-w-0 flex-1 items-center gap-2 rounded-md border border-input bg-background px-3 text-sm text-muted-foreground shadow-xs transition-colors duration-150 hover:bg-accent max-md:hidden md:max-w-sm focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
      >
        <Search className="size-4 shrink-0" aria-hidden />
        <span className="truncate">{t('core.shell.search_placeholder')}</span>
        <Kbd className="ml-auto">{t('core.shell.search_shortcut')}</Kbd>
      </button>
      <div className="ml-auto flex items-center gap-1">
        <Button variant="ghost" size="icon" onClick={() => openHelp('help')} aria-label={t('core.shell.help')}>
          <CircleHelp aria-hidden />
        </Button>
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  )
}
